// extracted by mini-css-extract-plugin
export default {"wrap":"pG-z","subtitle":"qG-z","contentWrap":"rG-z","imgWrap":"sG-z","heading":"tG-z","copy":"uG-z"};